import { AxiosError } from "axios";


export class Chat42Error extends Error {
    constructor(public code: string) {
        super(code);
        Object.setPrototypeOf(this, Chat42Error.prototype);
    }

    public readonly isChat42Error = true;
}

export const isChat42Error = (error: unknown): error is Chat42Error => {
    try {
        return (
            typeof error === "object" && error != null && "isChat42Error" in error && typeof (error as Record<string, unknown>).isChat42Error === "boolean"
        );
    } catch (e) {
        return false;
    }
};

export const isAxiosError = (error: unknown): error is AxiosError => {
    return (
        typeof error === "object" && error !== null && "isAxiosError" in error && typeof (error as Record<string, unknown>).isAxiosError === 'boolean'
    );
};

export const isSessionExpiredError = (error: unknown): error is AxiosError => {
    return isAxiosError(error) && error?.response?.status === 401;
};
